import { Tag } from '@fiverr-private/fit';

export default Tag;
